import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import '../styles/DrivingLicense.css'
import Footer from '../components/Footer'
import Card from '../components/Card'
import BackButton from '../components/BackButton'
import { getServiceTypes } from '../ServiceAPI/services/api'
// Import Lucide icons
import { FileText } from 'lucide-react'

const ServiceType = () => {
  const { serviceName } = useParams();
  // const navigate = useNavigate();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        const data = await getServiceTypes(serviceName);

        // Handle different response formats
        let typesArray = [];
        if (Array.isArray(data)) {
          typesArray = data;
        } else if (data.types && Array.isArray(data.types)) {
          typesArray = data.types;
        } else if (data.data && Array.isArray(data.data)) {
          typesArray = data.data;
        }

        setTypes(typesArray);
        setLoading(false);
      } catch (err) {
        console.error('Error:', err);
        setError('Failed to load service types');
        setLoading(false);
      }
    };

    if (serviceName) {
      fetchServiceTypes();
    }
  }, [serviceName]);
  return (
    <div className='license-container'>
      {/* Back Button */}
      <div className='p-4'>
        <BackButton />
      </div>

      {/* Enhanced Hero Section */}
      <div className='relative overflow-hidden'>
        <div className='absolute inset-0 bg-gradient-to-br from-blue-25 to-indigo-50 dark:from-gray-800 dark:to-gray-900 opacity-30'></div>
        <div className='relative pt-10 pb-10 px-4'>
          <div className='max-w-4xl mx-auto text-center'>
            {/* Animated Title */}
            <h1 className='text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6 animate-fade-in-up'>
              <span className='bg-gradient-to-r from-blue-500 to-indigo-500 bg-clip-text text-transparent'>
                {serviceName}
              </span>
              <span className='text-gray-700 dark:text-gray-300'> Services</span>
            </h1>

            {/* Enhanced Underline */}
            <div className='flex justify-center mb-6'>
              <div className='w-24 h-1 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full animate-scale-in'></div>
            </div>

            {/* Subtitle */}
            <p className='text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto leading-relaxed animate-fade-in-up animation-delay-300'>
              Choose from our comprehensive range of {serviceName.toLowerCase()} services.
              Fast, secure, and hassle-free processing with RTO Bharat.
            </p>
          </div>
        </div>
      </div>

      {/* Enhanced Cards Section */}
      <div className='py-5 px-4'>
        <div className='max-w-7xl mx-auto'>
          {loading ? (
            <div className='flex justify-center items-center py-20'>
              <div className='relative'>
                <div className='w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin'></div>
                <div className='mt-4 text-gray-600 dark:text-gray-300 text-center'>Loading service types...</div>
              </div>
            </div>
          ) : error ? (
            <div className='text-center py-20'>
              <div className='text-red-500 text-xl mb-4'>⚠️ {error}</div>
              <button
                onClick={() => window.location.reload()}
                className='px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors'
              >
                Try Again
              </button>
            </div>
          ) : (
            <div className='grid gap-8 justify-items-center' style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 400px))', justifyContent: 'center' }}>
              {types.map((type, index) => (
                <div
                  key={type.id}
                  className='group animate-fade-in-up'
                  style={{ animationDelay: `${index * 150}ms` }}
                >
                  <Card
                    title={type.Type}
                    content={
                      <div>
                        <p className='text-gray-600 dark:text-gray-300 mb-4'>
                          {type.description || `Apply for ${type.Type} services easily and securely through our digital platform.`}
                        </p>
                        {type.requirements && (
                          <div className='bg-gray-50 dark:bg-gray-700 p-4 rounded-lg'>
                            <p className="font-medium text-gray-800 dark:text-gray-200 mb-2 flex items-center">
                              📋 Required Documents:
                            </p>
                            <ul className="list-none space-y-1 text-sm">
                              {type.requirements.slice(0, 3).map((req, index) => (
                                <li key={index} className='flex items-center text-gray-600 dark:text-gray-300'>
                                  <span className='w-1.5 h-1.5 bg-blue-500 rounded-full mr-2'></span>
                                  {req}
                                </li>
                              ))}
                              {type.requirements.length > 3 && (
                                <li className='text-blue-600 dark:text-blue-400 text-xs'>
                                  +{type.requirements.length - 3} more documents
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    }
                    lcolor='bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300'
                    icon={FileText}
                    buttonText='Apply Now →'
                    link={`/service-cat/${encodeURIComponent(serviceName)}/${encodeURIComponent(type.Type)}`}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="footer-spacer"></div>
      <Footer />
    </div>
  )
}

export default ServiceType